import ReactTooltip from 'react-tooltip';

const Label = (props: any) => {
	const tooltip:any = {}
	const extra:any = {}

	if(props.tooltip || props.tooltipHTML) {
		tooltip['data-tip'] = props.tooltip ?? props.tooltipHTML;
		tooltip['data-html'] = !!props.tooltipHTML;
		tooltip.style = { fontWeight: 'bold' };
	}

	if(props.htmlFor) {
		extra.htmlFor = props.htmlFor
	}

	return <label
			className={props.className}
			onClick={(event) => {
				if(props.onClick && ((event.target as HTMLInputElement).value) === 'SPAN') {
					props.onClick(event)
				}
			}}
			{...extra}
		>
			<span {...tooltip}>
				{ props.title }
			</span>
			{
				tooltip['data-tip'] ? <ReactTooltip /> : null
			}
			{ props.children }
	</label>
}

export default Label;
